<template>
    <v-alert type="info" :value="!acceptCookies" color="rgba(159, 146, 137, 1)">
      <v-layout align-center>
        <v-flex xs10>
          This site uses cookies.
          By continuing to browse the site you are agreeing to our use of cookies.
        </v-flex>
        <v-flex>
          <v-btn @click="confirmCookies()">
            ok
          </v-btn>
        </v-flex>
      </v-layout>
    </v-alert>
</template>

<script>
export default {
  name: 'CookieAlert',
  data() {
    return {
      acceptCookies: false,
    };
  },
  mounted() {
    if (localStorage.acceptCookies) {
      this.acceptCookies = localStorage.acceptCookies;
    }
  },
  methods: {
    confirmCookies() {
      this.acceptCookies = true;
      localStorage.acceptCookies = true;
    },
  },
};
</script>

<style scoped>
  .v-alert {
    width: 100%;
    bottom: 0px;
    margin: 0px;
    border-width: 0px;
    position: fixed;
  }
</style>
